import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import AdminHeader from "./AdminHeader";
import AdminNavigation from "./AdminNavigation";
import AdminFooter from "./AdminFooter";
import { ToastContainer, toast } from "react-toastify";
import { get_Date } from "../../Utils/commonFunctions";
import {
  deleteSurveyAnalysisReportGraph,
  getSurveyAnalysisReportView,
  includeExcludeTextResponse,
} from "../../Utils/adminFunctions";
import { Bar } from "react-chartjs-2";
import {
  AdminQuestionOption,
  AdminReportGraph,
  AdminTextResponces,
} from "./AdminCommanComponent";

const AdminSurveyAnalysisReport = () => {
  const { surveyID } = useParams(); ///survey ID
  const [surveyData, setSurveyData] = useState("");
  const [analysisReport, setAnalysisReport] = useState("");
  const [tmpDeleteID, setTmpDeleteID] = useState("");
  const [tmpPopupchartData, setTmpPopupchartData] = useState([]);
  const [title, setTitle] = useState("");
  const labels = [""];
  const optionsChart = {
    indexAxis: "y",
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: true,
        text: title,
        padding: {
          top: 10,
          bottom: 10,
        },
        color: "#0069d9",
      },
      scales: {
        xaxis: {
          beginAtZero: true,
          ticks: {
            stepSize: 1.0,
          },
        },
      },
    },
  };
  useEffect(() => {
    AdminUserSurveyAnalysisReport();
  }, []);
  const AdminUserSurveyAnalysisReport = async () => {
    const bodyFormData = new FormData();
    bodyFormData.append("survey_id", surveyID);
    const response = await getSurveyAnalysisReportView(bodyFormData);
    // console.log(response)
    if (response.status == "success") {
      setSurveyData(response.data.survey_result[0]);
      let surveyStatus = response.data.survey_result[0].status;
      let colors = response.data.survey_result[0].COLOR;
      // console.log(Object.keys(response?.data?.anyreports))
      if (Object.keys(response?.data?.anyreports)?.length===0) {
        setAnalysisReport("");
      } else {
        let dataObject = response?.data?.anyreports;
        let isChart,
          options,
          reportChartsData,
          textResponcesData,
          tempChartData;
        let textResponcesInclude;
        let textResponseButton;
        let analysisReport = Object.keys(dataObject)?.map(function (key, index) {
          let questionType = dataObject[key]?.type;
          if (dataObject[key]?.reportscharts?.length === 0) {
            isChart = 0;
            tempChartData = "";
          } else {
            isChart = 1;
            reportChartsData = dataObject[key]?.reportscharts;
            tempChartData = Object.keys(reportChartsData)?.map(function (
              key,
              index2
            ) {
              let item = reportChartsData[key];
              return (
                <div
                  className="col-md-6 mb-4 d-flex align-items-stretch"
                  key={index2}
                >
                  <AdminReportGraph
                    reportsCharts={item}
                    key={index2}
                    handleDelete={handleDelete}
                    handlePopup={handlePopup}
                    surveyStatus={surveyStatus}
                  />
                </div>
              );
            });
          }
          if (dataObject[key]?.options === "") {
            options = "";
          } else {
            options = dataObject[key]?.options;
          }
          if (dataObject[key]?.textresponse?.length === 0) {
            textResponcesInclude = "";
            textResponseButton = "";
          } else {
            let question_id = dataObject[key]?.question_id;
            textResponseButton = (
              <div className="col-md-12 text-right mb-2 mt-2">
                <span className="text-primary">Text Responses</span>
                <br></br>
                <button
                  className="btn btn-sm custom-btn-primary"
                  id={"show_hide" + dataObject[key].question_id}
                  onClick={() => {
                    handleShowTextResponse(
                      "show_hide" + dataObject[key].question_id,
                      "text_response_div_" + dataObject[key].question_id
                    );
                  }}
                >
                  Show
                </button>{" "}
                {surveyStatus !== "survey_closed" && (
                  <>
                    {dataObject[key].isinclude === 0 && (
                      <button
                        className="btn btn-sm custom-btn-primary"
                        onClick={() => {
                          handleIncludeTextResponse(
                            dataObject[key].question_id
                          );
                        }}
                      >
                        Include
                      </button>
                    )}
                    {dataObject[key].isinclude === 1 && (
                      <button
                        className="btn btn-sm custom-btn-primary"
                        onClick={() => {
                          handleRemoveTextResponse(dataObject[key].question_id);
                        }}
                      >
                        Remove
                      </button>
                    )}
                  </>
                )}
              </div>
            );
            textResponcesData = dataObject[key].textresponse;
            textResponcesInclude = (
              <div
                className="row hidden-custom mb-4"
                key={index}
                id={"text_response_div_" + question_id}
              >
                <div className="col-md-12 text-left">
                  <h6 className="p-0">
                    <strong>Text response</strong>
                  </h6>
                  {Object.keys(textResponcesData).map(function (key, index3) {
                    let TextitemData = textResponcesData[key];
                    return (
                      <AdminTextResponces
                        label={TextitemData.label}
                        key={index3}
                        key1={index3}
                        textResponseItem={TextitemData.textresponseitem}
                      />
                    );
                  })}
                </div>
              </div>
            );
          }

          return (
            <div className="row" key={index}>
              {textResponseButton}
              <div className="col-md-12">
                <div className="sar-question p-1">
                  <div className="sar-question-number">{index + 1}</div>
                  <span className="sar-question-text">
                    {dataObject[key].label}
                    {dataObject[key].type === "survey"
                      ? " > " + dataObject[key].survey_label
                      : ""}
                  </span>
                </div>
                {(questionType === "radio" ||
                  questionType === "selectboxes" ||
                  questionType === "survey") && (
                  <AdminQuestionOption
                    questionType={questionType}
                    isChart={isChart}
                    options={options}
                    colors={colors}
                  />
                )}
              </div>
              {tempChartData}
              {textResponcesInclude != "" && textResponcesInclude}
            </div>
          );
        });
        setAnalysisReport(analysisReport);
      }
    } else {
      toast.error(response, { autoClose: 1500 });
    }
  };

  let handlePopup = (title, data) => {
    setTitle(title);
    setTmpPopupchartData(data);
  };

  const handleDelete = (analysisID) => {
    setTmpDeleteID(analysisID);
  };

  const handleShowTextResponse = (buttonID, textDivID) => {
    let btnText = document.getElementById(buttonID).innerHTML;
    let btn = document.getElementById(buttonID);

    if (btnText === "Show") {
      const box = document.getElementById(textDivID);
      box.classList.remove("hidden-custom");
      btn.innerHTML = "Hide";
    } else {
      const box = document.getElementById(textDivID);
      box.classList.add("hidden-custom");
      btn.innerHTML = "Show";
    }
  };
  //Include
  const handleIncludeTextResponse = async (questionID) => {
    const response = await includeExcludeTextResponse(
      surveyID,
      questionID,
      "include"
    );
    if (response.status == "success") {
      toast.success(response.message, { autoClose: 1500 });
      AdminUserSurveyAnalysisReport();
    } else {
      toast.warning(response.message, { autoClose: 1500 });
    }
  };
  //Exclude
  const handleRemoveTextResponse = async (questionID) => {
    const response = await includeExcludeTextResponse(
      surveyID,
      questionID,
      "exclude"
    );
    if (response.status == "success") {
      toast.success(response.message, { autoClose: 1500 });
      AdminUserSurveyAnalysisReport();
    } else {
      toast.warning(response.message, { autoClose: 1500 });
    }
  };

  const handleAdminAnalysisGraphDelete = async () => {
    const response = await deleteSurveyAnalysisReportGraph(
      surveyID,
      tmpDeleteID
    );
    if (response.status === "success") {
      toast.success(response.message, { autoClose: 1500 });
      document.getElementById("modal-default").click();
      AdminUserSurveyAnalysisReport();
    } else {
      toast.error(response.message, { autoClose: 1500 });
    }
  };

  return (
    <div>
      <ToastContainer></ToastContainer>
      <div className="modal fade show" id="modal-chart" arial-modal="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                id="close_modal"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <Bar
                options={optionsChart}
                data={{
                  labels,
                  datasets: tmpPopupchartData,
                }}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade show" id="modal-default" arial-modal="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Confirm delete</h4>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                id="close_modal"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <p>Are you sure you want to delete this record?</p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                data-dismiss="modal"
                className="btn btn-sm btn-dark"
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-sm btn-danger"
                onClick={() => handleAdminAnalysisGraphDelete()}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="wrapper">
        <div>
          <AdminHeader />
          <AdminNavigation />
          <div className="content-wrapper">
            <div className="content-header"></div>
            <section className="content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12">
                    <h3 className="card-title pull-right mb-2">
                      <Link
                        to={"/AdminListSurveyAnalysisReport/"}
                        className="btn btn-sm custom-btn-primary"
                      >
                        <i className="fa fa-arrow-left"></i> Back
                      </Link>
                    </h3>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12">
                    <div className="card">
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-12" id="page">
                            <table
                              className="table analysis-preview-table table-bordered"
                              id="surveyAnalysisReportTable"
                            >
                              <tbody>
                                <tr>
                                  <td colSpan={2}>
                                    <center>
                                      <img
                                        src={
                                          surveyData.manufacturer__company_logo
                                        }
                                        style={{
                                          maxHeight: "35px",
                                          margin: "10px",
                                          width: "auto",
                                        }}
                                      />
                                      <br></br>
                                      {surveyData.manufacturer__company_name}
                                    </center>
                                  </td>
                                  <td rowSpan={4}>
                                    <center>
                                      <img
                                        src={surveyData.device__device_image}
                                        style={{
                                          maxHeight: "150px",
                                          width: "auto",
                                        }}
                                      />
                                    </center>
                                  </td>
                                </tr>
                                <tr>
                                  <td colSpan={2}>
                                    <center>
                                      <b>{surveyData.survey_name}</b>
                                    </center>
                                  </td>
                                </tr>
                                <tr>
                                  <td className="width-20">No. of responses</td>
                                  <td className="width-60">
                                    {surveyData.no_of_responses}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="width-20">Launch Date</td>
                                  <td className="width-60">
                                    {get_Date(surveyData.launch_date)}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="width-20">Completion Date</td>
                                  <td className="width-60">
                                    {get_Date(surveyData.completion_date)}
                                  </td>
                                  <td>
                                    <center>
                                      {surveyData.device__device_name}
                                    </center>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        {analysisReport}
                        <p className="text-center mt-4">
                          {" "}
                          <Link
                            to={"/AdminSurveyAnalysisReportPreview/" + surveyID}
                            className="btn btn-sm custom-btn-primary"
                          >
                            Preview
                          </Link>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>

          <AdminFooter />
        </div>
      </div>
    </div>
  );
};

export default AdminSurveyAnalysisReport;
